import getters from './getters'
import actions from './actions'
import mutations from './mutations'

const state = {
    expenseTypeList:[],
    expenseList:[],
    expense:{
        amount : 0,
        paymentModeId : '',
        date : '',
        description :''
    }, 
    expenseType: {},
    monthlyExpenseAmount : 0
}

const expense = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}

export default expense;